// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.e2e_benchsales_form_overlay{

  position:fixed;

  inset:0;

  background:
  rgba(0,0,0,.55);

  backdrop-filter:blur(5px);

  display:flex;

  justify-content:center;

  align-items:center;

  z-index:9999;
}

.e2e_benchsales_form_modal{

  width:90%;

  max-width:1150px;

  max-height:90vh;

  overflow-y:auto;

  background:white;

  border-radius:18px;

  box-shadow:
  0 20px 60px rgba(0,0,0,.15);
}

.e2e_benchsales_form_header{

  display:flex;

  justify-content:space-between;

  align-items:center;

  padding:22px 30px;

  border-bottom:1px solid #e5e7eb;
}

.e2e_benchsales_form_header h2{

  font-size:28px;

  color:#111827;
}

.e2e_benchsales_form_header p{

  color:#6b7280;

  margin-top:4px;
}

.e2e_benchsales_form_close{

  width:42px;

  height:42px;

  border:none;

  border-radius:50%;

  cursor:pointer;

  background:#f3f4f6;

  font-size:18px;
}

.e2e_benchsales_form_grid{

  padding:30px;

  display:grid;

  grid-template-columns:
  repeat(3,1fr);

  gap:22px;
}

.e2e_benchsales_form_field{

  display:flex;

  flex-direction:column;
}

.e2e_benchsales_form_field label{

  margin-bottom:8px;

  font-size:14px;

  font-weight:600;

  color:#374151;
}

.e2e_benchsales_form_field input,
.e2e_benchsales_form_field select{

  height:46px;

  border:1px solid #d1d5db;

  border-radius:10px;

  padding:0 14px;

  background:#fff;
}

.e2e_benchsales_form_remarks{

  padding:0 30px 25px;
}

.e2e_benchsales_form_remarks label{

  display:block;

  margin-bottom:10px;

  font-weight:600;
}

.e2e_benchsales_form_remarks textarea{

  width:100%;

  height:120px;

  border:1px solid #d1d5db;

  border-radius:10px;

  padding:15px;

  resize:none;
}

.e2e_benchsales_upload_section{

  padding:0 30px 25px;

  display:grid;

  grid-template-columns:
  repeat(2,1fr);

  gap:18px;
}

.e2e_benchsales_upload_card{

  border:2px dashed #cbd5e1;

  border-radius:14px;

  padding:20px;

  text-align:center;

  background:#f8fafc;
}

.e2e_benchsales_upload_card h4{

  margin-bottom:15px;

  color:#1e293b;
}

.e2e_benchsales_upload_card button{

  border:none;

  background:#2563eb;

  color:white;

  padding:10px 20px;

  border-radius:10px;

  cursor:pointer;
}

.e2e_benchsales_form_buttons{

  display:flex;

  justify-content:flex-end;

  gap:15px;

  padding:20px 30px;

  border-top:1px solid #e5e7eb;
}

.e2e_benchsales_save_btn{

  border:none;

  background:#2563eb;

  color:white;

  padding:12px 28px;

  border-radius:10px;

  cursor:pointer;
}

.e2e_benchsales_cancel_btn{

  border:none;

  background:#e5e7eb;

  color:#111827;

  padding:12px 28px;

  border-radius:10px;

  cursor:pointer;
}

@media(max-width:768px){

  .e2e_benchsales_form_grid{

    grid-template-columns:1fr;
  }

  .e2e_benchsales_upload_section{

    grid-template-columns:1fr;
  }
}
.e2e_hidden_file{

  display:none;
}

.e2e_upload_label{

  display:flex;

  align-items:center;

  justify-content:center;

  width:100%;

  height:60px;

  cursor:pointer;

  font-size:15px;

  font-weight:600;

  color:#2563eb;

  transition:.3s;
}

.e2e_upload_label:hover{

  color:#1d4ed8;
}

.e2e_benchsales_upload_card{

  border:2px dashed #dbe2ea;

  border-radius:14px;

  background:#fafafa;

  transition:.3s;

  min-height:80px;

  display:flex;

  align-items:center;

  justify-content:center;
}

.e2e_benchsales_upload_card:hover{

  border-color:#2563eb;

  background:#f8fbff;
}
/* ==========================
   UPLOAD SECTION
========================== */

.joblist_form_upload_section{
  padding:0 25px 25px;

  display:grid;

  grid-template-columns:
  repeat(2,1fr);

  gap:18px;
}

.joblist_form_upload_card{
  border:2px dashed #dbe2ea;

  border-radius:14px;

  background:#fafafa;

  min-height:90px;

  display:flex;

  justify-content:center;

  align-items:center;

  transition:.3s;
}

.joblist_form_upload_card:hover{
  border-color:#2563eb;

  background:#f8fbff;

  transform:translateY(-2px);
}

.joblist_hidden_file{
  display:none;
}

.joblist_upload_label{
  width:100%;

  height:100%;

  display:flex;

  align-items:center;

  justify-content:center;

  cursor:pointer;

  font-size:15px;

  font-weight:600;

  color:#2563eb;

  transition:.3s;

  padding:20px;
}

.joblist_upload_label:hover{
  color:#1d4ed8;
}

@media(max-width:768px){

  .joblist_form_upload_section{
    grid-template-columns:1fr;
  }

}`, "",{"version":3,"sources":["webpack://./src/styles/newbenchsalesform.css"],"names":[],"mappings":"AAAA;;EAEE,cAAc;;EAEd,OAAO;;EAEP;iBACe;;EAEf,yBAAyB;;EAEzB,YAAY;;EAEZ,sBAAsB;;EAEtB,kBAAkB;;EAElB,YAAY;AACd;;AAEA;;EAEE,SAAS;;EAET,gBAAgB;;EAEhB,eAAe;;EAEf,eAAe;;EAEf,gBAAgB;;EAEhB,kBAAkB;;EAElB;6BAC2B;AAC7B;;AAEA;;EAEE,YAAY;;EAEZ,6BAA6B;;EAE7B,kBAAkB;;EAElB,iBAAiB;;EAEjB,+BAA+B;AACjC;;AAEA;;EAEE,cAAc;;EAEd,aAAa;AACf;;AAEA;;EAEE,aAAa;;EAEb,cAAc;AAChB;;AAEA;;EAEE,UAAU;;EAEV,WAAW;;EAEX,WAAW;;EAEX,iBAAiB;;EAEjB,cAAc;;EAEd,kBAAkB;;EAElB,cAAc;AAChB;;AAEA;;EAEE,YAAY;;EAEZ,YAAY;;EAEZ;eACa;;EAEb,QAAQ;AACV;;AAEA;;EAEE,YAAY;;EAEZ,qBAAqB;AACvB;;AAEA;;EAEE,iBAAiB;;EAEjB,cAAc;;EAEd,eAAe;;EAEf,aAAa;AACf;;AAEA;;;EAGE,WAAW;;EAEX,wBAAwB;;EAExB,kBAAkB;;EAElB,cAAc;;EAEd,eAAe;AACjB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;;EAEb,kBAAkB;;EAElB,eAAe;AACjB;;AAEA;;EAEE,UAAU;;EAEV,YAAY;;EAEZ,wBAAwB;;EAExB,kBAAkB;;EAElB,YAAY;;EAEZ,WAAW;AACb;;AAEA;;EAEE,mBAAmB;;EAEnB,YAAY;;EAEZ;eACa;;EAEb,QAAQ;AACV;;AAEA;;EAEE,yBAAyB;;EAEzB,kBAAkB;;EAElB,YAAY;;EAEZ,iBAAiB;;EAEjB,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;;EAElB,aAAa;AACf;;AAEA;;EAEE,WAAW;;EAEX,kBAAkB;;EAElB,WAAW;;EAEX,iBAAiB;;EAEjB,kBAAkB;;EAElB,cAAc;AAChB;;AAEA;;EAEE,YAAY;;EAEZ,wBAAwB;;EAExB,QAAQ;;EAER,iBAAiB;;EAEjB,4BAA4B;AAC9B;;AAEA;;EAEE,WAAW;;EAEX,kBAAkB;;EAElB,WAAW;;EAEX,iBAAiB;;EAEjB,kBAAkB;;EAElB,cAAc;AAChB;;AAEA;;EAEE,WAAW;;EAEX,kBAAkB;;EAElB,aAAa;;EAEb,iBAAiB;;EAEjB,kBAAkB;;EAElB,cAAc;AAChB;;AAEA;;EAEE;;IAEE,yBAAyB;EAC3B;;EAEA;;IAEE,yBAAyB;EAC3B;AACF;AACA;;EAEE,YAAY;AACd;;AAEA;;EAEE,YAAY;;EAEZ,kBAAkB;;EAElB,sBAAsB;;EAEtB,UAAU;;EAEV,WAAW;;EAEX,cAAc;;EAEd,cAAc;;EAEd,eAAe;;EAEf,aAAa;;EAEb,cAAc;AAChB;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,yBAAyB;;EAEzB,kBAAkB;;EAElB,kBAAkB;;EAElB,cAAc;;EAEd,eAAe;;EAEf,YAAY;;EAEZ,kBAAkB;;EAElB,sBAAsB;AACxB;;AAEA;;EAEE,oBAAoB;;EAEpB,kBAAkB;AACpB;AACA;;4BAE4B;;AAE5B;EACE,mBAAmB;;EAEnB,YAAY;;EAEZ;eACa;;EAEb,QAAQ;AACV;;AAEA;EACE,yBAAyB;;EAEzB,kBAAkB;;EAElB,kBAAkB;;EAElB,eAAe;;EAEf,YAAY;;EAEZ,sBAAsB;;EAEtB,kBAAkB;;EAElB,cAAc;AAChB;;AAEA;EACE,oBAAoB;;EAEpB,kBAAkB;;EAElB,0BAA0B;AAC5B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;;EAEV,WAAW;;EAEX,YAAY;;EAEZ,kBAAkB;;EAElB,sBAAsB;;EAEtB,cAAc;;EAEd,cAAc;;EAEd,eAAe;;EAEf,aAAa;;EAEb,cAAc;;EAEd,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE;IACE,yBAAyB;EAC3B;;AAEF","sourcesContent":[".e2e_benchsales_form_overlay{\n\n  position:fixed;\n\n  inset:0;\n\n  background:\n  rgba(0,0,0,.55);\n\n  backdrop-filter:blur(5px);\n\n  display:flex;\n\n  justify-content:center;\n\n  align-items:center;\n\n  z-index:9999;\n}\n\n.e2e_benchsales_form_modal{\n\n  width:90%;\n\n  max-width:1150px;\n\n  max-height:90vh;\n\n  overflow-y:auto;\n\n  background:white;\n\n  border-radius:18px;\n\n  box-shadow:\n  0 20px 60px rgba(0,0,0,.15);\n}\n\n.e2e_benchsales_form_header{\n\n  display:flex;\n\n  justify-content:space-between;\n\n  align-items:center;\n\n  padding:22px 30px;\n\n  border-bottom:1px solid #e5e7eb;\n}\n\n.e2e_benchsales_form_header h2{\n\n  font-size:28px;\n\n  color:#111827;\n}\n\n.e2e_benchsales_form_header p{\n\n  color:#6b7280;\n\n  margin-top:4px;\n}\n\n.e2e_benchsales_form_close{\n\n  width:42px;\n\n  height:42px;\n\n  border:none;\n\n  border-radius:50%;\n\n  cursor:pointer;\n\n  background:#f3f4f6;\n\n  font-size:18px;\n}\n\n.e2e_benchsales_form_grid{\n\n  padding:30px;\n\n  display:grid;\n\n  grid-template-columns:\n  repeat(3,1fr);\n\n  gap:22px;\n}\n\n.e2e_benchsales_form_field{\n\n  display:flex;\n\n  flex-direction:column;\n}\n\n.e2e_benchsales_form_field label{\n\n  margin-bottom:8px;\n\n  font-size:14px;\n\n  font-weight:600;\n\n  color:#374151;\n}\n\n.e2e_benchsales_form_field input,\n.e2e_benchsales_form_field select{\n\n  height:46px;\n\n  border:1px solid #d1d5db;\n\n  border-radius:10px;\n\n  padding:0 14px;\n\n  background:#fff;\n}\n\n.e2e_benchsales_form_remarks{\n\n  padding:0 30px 25px;\n}\n\n.e2e_benchsales_form_remarks label{\n\n  display:block;\n\n  margin-bottom:10px;\n\n  font-weight:600;\n}\n\n.e2e_benchsales_form_remarks textarea{\n\n  width:100%;\n\n  height:120px;\n\n  border:1px solid #d1d5db;\n\n  border-radius:10px;\n\n  padding:15px;\n\n  resize:none;\n}\n\n.e2e_benchsales_upload_section{\n\n  padding:0 30px 25px;\n\n  display:grid;\n\n  grid-template-columns:\n  repeat(2,1fr);\n\n  gap:18px;\n}\n\n.e2e_benchsales_upload_card{\n\n  border:2px dashed #cbd5e1;\n\n  border-radius:14px;\n\n  padding:20px;\n\n  text-align:center;\n\n  background:#f8fafc;\n}\n\n.e2e_benchsales_upload_card h4{\n\n  margin-bottom:15px;\n\n  color:#1e293b;\n}\n\n.e2e_benchsales_upload_card button{\n\n  border:none;\n\n  background:#2563eb;\n\n  color:white;\n\n  padding:10px 20px;\n\n  border-radius:10px;\n\n  cursor:pointer;\n}\n\n.e2e_benchsales_form_buttons{\n\n  display:flex;\n\n  justify-content:flex-end;\n\n  gap:15px;\n\n  padding:20px 30px;\n\n  border-top:1px solid #e5e7eb;\n}\n\n.e2e_benchsales_save_btn{\n\n  border:none;\n\n  background:#2563eb;\n\n  color:white;\n\n  padding:12px 28px;\n\n  border-radius:10px;\n\n  cursor:pointer;\n}\n\n.e2e_benchsales_cancel_btn{\n\n  border:none;\n\n  background:#e5e7eb;\n\n  color:#111827;\n\n  padding:12px 28px;\n\n  border-radius:10px;\n\n  cursor:pointer;\n}\n\n@media(max-width:768px){\n\n  .e2e_benchsales_form_grid{\n\n    grid-template-columns:1fr;\n  }\n\n  .e2e_benchsales_upload_section{\n\n    grid-template-columns:1fr;\n  }\n}\n.e2e_hidden_file{\n\n  display:none;\n}\n\n.e2e_upload_label{\n\n  display:flex;\n\n  align-items:center;\n\n  justify-content:center;\n\n  width:100%;\n\n  height:60px;\n\n  cursor:pointer;\n\n  font-size:15px;\n\n  font-weight:600;\n\n  color:#2563eb;\n\n  transition:.3s;\n}\n\n.e2e_upload_label:hover{\n\n  color:#1d4ed8;\n}\n\n.e2e_benchsales_upload_card{\n\n  border:2px dashed #dbe2ea;\n\n  border-radius:14px;\n\n  background:#fafafa;\n\n  transition:.3s;\n\n  min-height:80px;\n\n  display:flex;\n\n  align-items:center;\n\n  justify-content:center;\n}\n\n.e2e_benchsales_upload_card:hover{\n\n  border-color:#2563eb;\n\n  background:#f8fbff;\n}\n/* ==========================\n   UPLOAD SECTION\n========================== */\n\n.joblist_form_upload_section{\n  padding:0 25px 25px;\n\n  display:grid;\n\n  grid-template-columns:\n  repeat(2,1fr);\n\n  gap:18px;\n}\n\n.joblist_form_upload_card{\n  border:2px dashed #dbe2ea;\n\n  border-radius:14px;\n\n  background:#fafafa;\n\n  min-height:90px;\n\n  display:flex;\n\n  justify-content:center;\n\n  align-items:center;\n\n  transition:.3s;\n}\n\n.joblist_form_upload_card:hover{\n  border-color:#2563eb;\n\n  background:#f8fbff;\n\n  transform:translateY(-2px);\n}\n\n.joblist_hidden_file{\n  display:none;\n}\n\n.joblist_upload_label{\n  width:100%;\n\n  height:100%;\n\n  display:flex;\n\n  align-items:center;\n\n  justify-content:center;\n\n  cursor:pointer;\n\n  font-size:15px;\n\n  font-weight:600;\n\n  color:#2563eb;\n\n  transition:.3s;\n\n  padding:20px;\n}\n\n.joblist_upload_label:hover{\n  color:#1d4ed8;\n}\n\n@media(max-width:768px){\n\n  .joblist_form_upload_section{\n    grid-template-columns:1fr;\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
